import { render, staticRenderFns } from "./HuntingLicenseOrderCharges.vue?vue&type=template&id=0fd8e470&"
import script from "./HuntingLicenseOrderCharges.vue?vue&type=script&lang=ts&"
export * from "./HuntingLicenseOrderCharges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports